import { MessageBus } from "@/utils/message.bus";

export type ToastMessageBusEvent = "ERROR" | "REGULAR";
export const TOAST_MESSAGE_BUS = new MessageBus<ToastMessageBusEvent>();
